<template>
  <div class="container">
    <div class="top-bg">
      <!--  <div class="return" @click="linkytowin">
        <img src="../../static/images/icon_logo.png" alt="">
      </div>-->
      <img src="../../static/images/qie01.jpg" alt />
    </div>
    <div class="ct">
      <ul class="breadnav ct-centre">
        <li @click="linkytowin">
          <img src="../../static/images/icon_logo.png" alt="" />
        </li>
        <li class="icon">&gt;</li>
        <li @click="linkindex">专题首页</li>
        <li class="icon">&gt;</li>
        <li>课程页面</li>
      </ul>
      <!--<shaixuan></shaixuan>-->
      <div class="tcDetails ct-centre">
        <div class="tcDetails-title">
          <img src="../../static/images/title-l.png" alt />
          <h3>课程介绍</h3>
          <img src="../../static/images/title-r.png" alt />
        </div>
        <div class="tcDetails-ct">
          <div class="tcDetails-ct-top">
            <!--<div style="width: 537px;height: 302px" v-if="videoData.url2">-->

            <!--</div>-->
            <iframe
              v-if="videoData.url2 == ''"
              :src="videoData.url"
              scrolling="no"
              border="0"
              frameborder="no"
              framespacing="0"
              allowfullscreen="true"
              style="width:537px;height:302px;"
            ></iframe>
            <div id="txvideo" style="width: 537px; height: 302px;" v-else></div>
            <div class="teacherInfo">
              <div class="teacherInfo-top">
                <div class="teacherInfo-name">
                  <div class="name-top">
                    <h4>{{ videoData.name }}</h4>
                    <span
                      >{{ videoData.grade }}{{ videoData.subject }} 丨 直播上课
                      丨 无限回放 丨 1V1辅导</span
                    >
                  </div>
                  <div class="name-bt">
                    <div class="name-bt-l">
                      <h4>授课老师</h4>
                    </div>
                    <div class="name-bt-r">
                      <span>{{ videoData.teacher }}</span>
                      <p>{{ videoData.tags }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="teacherInfo-ct-bt">
                <h5>新年大促：</h5>
                <ul>
                  <li>
                    单科95折<img
                      src="../../static//images/unify-ewm.png"
                      alt=""
                    />
                  </li>
                  <li>
                    双科9折<img
                      src="../../static//images/unify-ewm.png"
                      alt=""
                    />
                  </li>
                  <li>
                    三科88折<img
                      src="../../static//images/unify-ewm.png"
                      alt=""
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tcDetails-bt-class ct-centre">
        <div class="tcDetails-title">
          <img src="../../static/images/title-l.png" alt />
          <h3>推荐课程</h3>
          <img src="../../static/images/title-r.png" alt />
        </div>
        <div class="test-ct">
          <ul>
            <li
              class="test-ct-li"
              v-for="(item, index) in indexDataclass"
              :key="index"
              @click="linkivideodetails(item)"
            >
              <div class="class-bg">
                <img
                  class="class-bt"
                  src="../../static/images/class-bt.png"
                  alt
                />
                <div class="class-text">
                  <h5>{{ item.name }}</h5>
                </div>
                <img src="../../static/images/class-bg.png" alt />
              </div>
              <div class="test-ct-text">
                <h3 :title="item.name">{{ item.name }}</h3>
                <div class="text-c">
                  <i>{{ item.teacher }}</i>
                  <span :title="item.tags">{{ item.tags }}</span>
                </div>
                <div class="text-bt">
                  <p>直播上课</p>
                  <p>无限回放</p>
                  <p>1V1辅导</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tcDetails-bt ct-centre">
      <div class="tcDetails-title">
        <img src="../../static/images/title-l.png" alt />
        <h3>高考奖学金获奖名单</h3>
        <img src="../../static/images/title-r.png" alt />
      </div>
      <div class="award">
        <ul>
          <li
            @click="gk_zuiqiang"
            :class="{ active: gk_zq_nm == gk_activenum }"
          >
            最强学神奖
          </li>
          <li @click="gk_chaofan" :class="{ active: gk_cf_nm == gk_activenum }">
            超凡学霸奖
          </li>
          <li @click="gk_ronyao" :class="{ active: gk_ry_nm == gk_activenum }">
            荣耀学豪奖
          </li>
          <li @click="gk_feuyue" :class="{ active: gk_fy_nm == gk_activenum }">
            飞跃进步奖
          </li>
        </ul>
        <div class="award-ct" v-if="gk_zq_nm == gk_activenum">
          <div class="award-c-top">
            <p>
              在2019年高考中，被<i>“五大高校”录取</i>（清华大学、北京大学
              浙江大学、复旦大学、上海交通）。奖项包括：<i>大学一年学费全包(5000元现金)+腾讯企鹅辅导实习资格</i>（获奖的同学需在企鹅辅导开课分享学习心得&学习笔记）。
            </p>
            <div>
              <img src="../../static/images/lv1.png" alt />
            </div>
          </div>
          <div class="award-c-m">
            <div class="head">
              <img src="../../static/images/st/王永靖.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>王永靖</h4>
                    <span>贵州省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>浙江大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>657</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                当得知高考录取结果时，我知道，这个考试终于结束了，我的人生也将开始一段新征程、企鹅辅导里我最感谢的是英语老师月姐，之前英语一直是我的短板，后来在月姐的帮助下，我的这个短板被逐渐修复，最后甚至变成了我的强项，虽然这次高考英语考得不是很满意，但是比以前的自己提高了很多，感谢企鹅辅导，让我遇见了更好的自己!愿企鵝辅导更加努力，做更好的在线教育
              </div>
            </div>
          </div>
          <div class="award-c-bt">
            <div class="head">
              <img src="../../static/images/st/赵瑞.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>赵瑞</h4>
                    <span>贵州省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>复旦大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>661</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                首先非常感谢企鹅辅导能给我们高考学子一个这样的机会，这是对我们12年求学成果的最大肯定!在我求学期间，我一直在使用企鹅辅导进行专项提升，老师们的循循善诱与谆谆教诲，极高的性价比都让我们对企鹅辅导赞叹不已。祝企鹅辅导的全体工作人员与老师身体健康、万事如意，今后我也一定会继续努力，成为真正对社会国家有用之才！
              </div>
            </div>
          </div>
        </div>

        <div class="award-ct" v-if="gk_cf_nm == gk_activenum">
          <div class="award-c-top">
            <p>
              在2019年高考中，被<i>“985工程院校”</i>录取，含全国39所“985”工程院校。奖项包括：<i>华为荣耀平板电脑+腾讯企鹅辅导实习资格</i>（获奖的同学需在企鹅辅导开课分享学习心得&学习笔记）。
            </p>
            <div>
              <img src="../../static/images/lv2.png" alt />
            </div>
          </div>
          <div class="award-c-m">
            <div class="head">
              <img src="../../static/images/st/刘仁杰.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>刘仁杰</h4>
                    <span>贵州省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>国防科技大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>648</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                在高考前面的几个月，我倒是经常用企鹅辅导来抓弱点(例如物理综合场，英语的高级句式)所以能考上一个好大学，企鹅辅导功不可没。!愿企鵝辅导更加努力，做更好的在线教育
              </div>
            </div>
          </div>
          <div class="award-c-bt">
            <div class="head">
              <img src="../../static/images/st/武培瑞.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>武培瑞</h4>
                    <span>甘肃省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>华东师范大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>600</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                高一的时候广告推送了企鹅辅导，从此入坑不得自拔一直跟着企鹅辅导学习自己的薄弱科目，上高三时语文特别不理想，直到上了齐霁老师的课后语文有了很大的提升，齐霁老师会把一些绕的东西分成几个小部分，非常好理解，最后语文也考了不错的成绩。感谢齐霁老师，感谢企鹅辅导。
              </div>
            </div>
          </div>
        </div>

        <div class="award-ct" v-if="gk_ry_nm == gk_activenum">
          <div class="award-c-top">
            <p>
              在2019年高考中，被
              <i>“211院校”录取</i
              >，含全国112所“211”工程院校。奖项包括：<i>小私AI人工智能音箱</i>获奖的同学需在企鹅辅导开课分享学习心得&学习笔记）。
            </p>
            <div>
              <img src="../../static/images/lv3.png" alt />
            </div>
          </div>
          <div class="award-c-m">
            <div class="head">
              <img src="../../static/images/st/齐飞.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>齐飞</h4>
                    <span>四川省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>武汉理工大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>三年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>618</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                我是在高一的时候遇见企鹅辅导的,记得是在QQ上看见的,一次尝试便结下了不解之缘,后来上高二高三时也直在上企鹅的课,高三冲刺的时候,还报了一个英语课,因为相信,付出一定会有进步。未来长路,因有企鹅,会更加精彩!
              </div>
            </div>
          </div>
          <div class="award-c-bt">
            <div class="head">
              <img src="../../static/images/st/高源.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>高源</h4>
                    <span>山东省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>哈尔滨工业大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>607</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                从qq空间里得知企鹅辅导，就赶快下载了一个。抱着试
                一试的心态体验了免费课程，觉得这里的老师没有架
                子,非常温和耐心，讲解题目的角度也十分新颖。我很感谢企鹅辅导，让我这种十八线城市的孩子也能平等地通
                过互联网和同龄人共享优质教育资源，不仅让我在艰难备考期间获得了企鹅老师们的鼓励与支持，更让我见识了“原来高中课程也能这么好玩”。谢谢企鹅辅导，让我高考实现新的突破！
              </div>
            </div>
          </div>
        </div>

        <div class="award-ct" v-if="gk_fy_nm == gk_activenum">
          <div class="award-c-top">
            <p>
              高考总分比一模总分<i>进步50分以上</i>，高考单科成绩比一模总分<i>进步20分以上</i>，满足以上任一条件即可申请。奖项包括：<i>魅族蓝牙运动耳机</i>（获奖的同学需在企鹅辅导开课分享学习心得&学习笔记）。
            </p>
            <div>
              <img src="../../static/images/lv4.png" alt />
            </div>
          </div>
          <div class="award-c-m">
            <div class="head">
              <img src="../../static/images/st/吕梦涵.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>吕梦涵</h4>
                    <span>四川省</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>天津师范大学</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>一年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>575</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                是月姐,教会了很多学习英语的方法，使我的英语提高了30分，感谢月姐,感谢企鹅辅导，你们照亮了我的路。
              </div>
            </div>
          </div>
          <div class="award-c-bt">
            <div class="head">
              <img src="../../static/images/st/石洋.jpg" alt />
            </div>
            <div class="info">
              <div class="basic">
                <div class="self">
                  <div class="name">
                    <h4>石洋</h4>
                    <span>北京市</span>
                  </div>
                  <div class="condition">
                    <div class="school">
                      <h5>录取院校：</h5>
                      <span>首都师范大学科德学院</span>
                    </div>
                    <div class="qe">
                      <h5>企鹅辅导使用时间：</h5>
                      <span>两年</span>
                    </div>
                  </div>
                </div>
                <div class="score">
                  <i>高考成绩</i>
                  <div class="shu">
                    <span>450</span>
                    <i>分</i>
                  </div>
                </div>
              </div>
              <div class="text">
                企鹅辅导的英语郝老师非常棒,让我把英语成绩从不到100分提到了
                114分。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tcDetails-bt ct-centre">
      <div class="tcDetails-title">
        <img src="../../static/images/title-l.png" alt />
        <h3>高三毕业生对企鹅辅导的暖心告白</h3>
        <img src="../../static/images/title-r.png" alt />
      </div>
      <div class="confession">
        <ul>
          <li>
            <img src="../../static/images/confession-bg.jpg" alt />
            <div class="confession-text">
              <h5 class="name">石兴军</h5>
              <p>
                高三备考，苦中有乐，无数次的迷茫中，企鹅辅导给了我帮助，像明灯，引领着我走出迷茫,一步步走向属于自己的成功，谢谢企鹅辅导的陪伴与支持。
              </p>
            </div>
          </li>
          <li>
            <img src="../../static/images/confession-bg.jpg" alt />
            <div class="confession-text">
              <h5 class="name">张一淼</h5>
              <p>
                有幸在高一时就结识了企鹅辅导。数学一直是我的硬伤，而企鹅辅导的超市老师和强哥给予了我很多帮助。
              </p>
            </div>
          </li>
          <li>
            <img src="../../static/images/confession-bg.jpg" alt />
            <div class="confession-text">
              <h5 class="name">高海卿</h5>
              <p>
                通过企鹅辅导，让我的知识得到了巩固和提升,收获了很多，成绩也有了稳步的提升！
              </p>
            </div>
          </li>
          <li>
            <img src="../../static/images/confession-bg.jpg" alt />
            <div class="confession-text">
              <h5 class="name">袁 敖</h5>
              <p>
                在高三最后的复习阶段，企鹅辅导不光给我增添了知识储备，老师们也给了我面对困难迎难而上的勇气和力量。
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tcDetails-bt ct-centre">
      <div class="tcDetails-title">
        <img src="../../static/images/title-l.png" alt />
        <h3>中考奖学金榜单</h3>
        <img src="../../static/images/title-r.png" alt />
      </div>
      <div class="award" id="ranking">
        <ul>
          <li @click="zk_zuiqiang" :class="{ active: zq_nm == activenum }">
            最强学神奖
          </li>
          <li @click="zk_chaofan" :class="{ active: cf_nm == activenum }">
            超凡学霸奖
          </li>
          <li @click="zk_ronyao" :class="{ active: ry_nm == activenum }">
            荣耀学豪奖
          </li>
          <li @click="zk_feuyue" :class="{ active: fy_nm == activenum }">
            飞跃进步奖
          </li>
        </ul>
        <div class="table">
          <el-table
            :data="studentData"
            height="320"
            border
            style="width:1127px"
          >
            <el-table-column
              prop="name"
              label="姓名"
              width="260"
            ></el-table-column>
            <el-table-column
              prop="school"
              label="毕业学校"
              width="470"
            ></el-table-column>
            <el-table-column
              prop="level"
              label="中考成就"
              width="396"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <floatewm class="floatewm"></floatewm>
  </div>
</template>

<script>
import teacherData from "../../static/json/data.js";
import shaixuan from "../components/shaixuan";
import floatewm from "../components/floatewm";

export default {
  components: {
    shaixuan: shaixuan,
    floatewm: floatewm
  },
  data() {
    return {
      studentData: [],
      linkvideo: {},
      videoData: {},
      /* classifycurrent: 0,
      gradecurrent: 0,
      subjectcurrent: 0,
      formcurrent: 0,
      classify: [
        { text: "全部" },
        { text: "小学" },
        { text: "初中" },
        { text: "高中" }
      ],
      grade: [
        { text: "全部" },
        { text: "一年级" },
        { text: "二年级" },
        { text: "三年级" },
        { text: "四年级" },
        { text: "五年级" },
        { text: "六年级" },
        { text: "初一" },
        { text: "初二" },
        { text: "初三" },
        { text: "高一" },
        { text: "高二" },
        { text: "高三" }
      ],
      subject: [
        { text: "全部" },
        { text: "语文" },
        { text: "数学" },
        { text: "英语" },
        { text: "物理" },
        { text: "化学" },
        { text: "生物" },
        { text: "政治" },
        { text: "历史" },
        { text: "地理" }
      ],
      form: [{ text: "试听课程" }, { text: "老师简介" }],*/
      videosData: teacherData._videosData(),
      indexDataclass: [],
      zq: teacherData._fortissimo(),
      cf: [],
      ry: [],
      cj: [],
      //中考鼠标hover的条件
      activenum: 0,
      zq_nm: 0,
      cf_nm: 1,
      ry_nm: 2,
      fy_nm: 3,
      //高考鼠标hover的条件
      gk_activenum: 0,
      gk_zq_nm: 0,
      gk_cf_nm: 1,
      gk_ry_nm: 2,
      gk_fy_nm: 3
    };
  },
  mounted() {
    if (localStorage.getItem("linkvideo") != "") {
      this.videoData = JSON.parse(localStorage.getItem("linkvideo"));
    } else {
      this.videoData = this.$route.query.data;
    }
    for (var i = 0; 4 > i; i++) {
      // if (this.videosData[i].grade.indexOf("高") != -1) {
      //   this.indexDataclass.push(this.videosData[i]);
      //   if (this.indexDataclass.length == 4) {
      //     break;
      //   }
      this.indexDataclass.push(
        this.videosData[Math.floor(Math.random() * this.videosData.length + 0)]
      );
      // }
      Math.floor(Math.random() * 10 + 1);
      this.studentData = this.zq;
    }

    var _teacher_img = "./static/images/tc/" + this.videoData.teacher + ".jpg";

    var videoObject = {
      container: "#txvideo",
      variable: "player",
      autoplay: false,
      poster: _teacher_img,
      video: [[this.videoData.url2, "video/mp4", "中文标清", 0]]
    };
    var player = new ckplayer(videoObject);
    player.changeControlBarShow(false);
  },
  methods: {
    /* classifyclickact: function(index) {
      this.classifycurrent = index;
    },
    gradeclickact: function(index) {
      this.gradecurrent = index;
    },
    subjectclickact: function(index) {
      this.subjectcurrent = index;
    },
    formclickact: function(index) {
      this.formcurrent = index;
    },*/
    linkytowin() {
      window.location.href = "http://www.ytowin.com/";
    },
    linkivideodetails(item) {
      /*     console.log(item);*/
      this.linkvideo = item;
      localStorage.setItem("linkvideo", JSON.stringify(this.linkvideo));
      this.$router.push({
        path: "/videodetails",
        query: {
          data: this.linkvideo,
          a: Math.ceil(Math.random() * 10)
        }
      });
    },
    zk_zuiqiang() {
      this.studentData = this.zq;
      this.activenum = 0;
    },
    zk_chaofan() {
      this.cf = teacherData._cf();
      this.studentData = this.cf;
      this.activenum = 1;
    },
    zk_ronyao() {
      this.ry = teacherData._ry();
      this.studentData = this.ry;
      this.activenum = 2;
    },
    zk_feuyue() {
      this.cj = teacherData._cj();
      this.studentData = this.cj;
      this.activenum = 3;
    },
    gk_zuiqiang() {
      this.gk_activenum = 0;
    },
    gk_chaofan() {
      this.gk_activenum = 1;
    },
    gk_ronyao() {
      this.gk_activenum = 2;
    },
    gk_feuyue() {
      this.gk_activenum = 3;
    },
    linkindex() {
      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: 0,
          gradecurrent: 0,
          subjectcurrent: 0,
          datescurrent: 0,
          formcurrent: 0,
          data: {
            classify: "高中",
            grade: "全部",
            subject: "全部",
            dates: "全部"
          },
          link: "/videolist"
        })
      );
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  .ct {
    width: 100%;
    margin: 20px auto;
  }
  .breadnav {
    margin: 20px auto;
    li {
      display: inline-block;
      color: #5bab52;
      cursor: pointer;
      &:last-child {
        color: #5bab52;
      }
      img {
        width: 78px;
        height: 33px;
        vertical-align: middle;
      }
    }
    .icon {
      color: #5bab52;
    }
  }
  .top-bg {
    .return {
      width: 1200px;
      margin: 0 auto;
      position: absolute;
      position: relative;
      span {
        cursor: pointer;
        left: 97%;
        top: -15px;
        padding: 95px 7px 5px 7px;
        color: #fff;
        text-align: center;
        width: 30px;
        height: 160px;
        position: absolute;
        background: url("../../static/images/return.png") no-repeat;
        background-size: 100%;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      span:hover {
        top: 0px;
      }
    }
    img {
      width: 100%;
      min-width: 1200px;
    }
  }
  .tcDetails {
    margin: 100px auto 0;
    /*margin-top: 100px;*/
    .tcDetails-title {
      display: flex;
      justify-content: center;
      margin-bottom: 73px;
      > h3 {
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
      }
    }
    .tcDetails-ct {
      .tcDetails-ct-top {
        display: flex;
        justify-content: space-between;
        .classVideo {
          position: relative;
          width: 621px;
          height: 349px;
          > iframe {
            width: 621px;
            height: 349px;
          }
          .classVideo-bt {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -29px;
            margin-top: -29px;
            width: 58px;
            height: 58px;
            background: #333333;
          }
        }
        .teacherInfo {
          width: 620px;
          height: 349px;
          .teacherInfo-top {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px dashed #dddddd;
            box-sizing: border-box;
            padding-bottom: 35px;
            margin-bottom: 29px;
            .teacherInfo-name {
              .name-top {
                > h4 {
                  font-size: 28px;
                  font-weight: normal;
                  color: #333333;
                  color: #333333;
                }
                > span {
                  display: block;
                  margin-top: 20px;
                  font-size: 18px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 30px;
                  letter-spacing: 0px;
                  color: #666666;
                }
              }
              .name-bt {
                margin-top: 37px;
                display: flex;
                .name-bt-l {
                  display: flex;
                  margin-right: 20px;
                  justify-content: center;
                  align-items: center;
                  width: 74px;
                  height: 74px;
                  background-color: #ffba00;
                  border-radius: 4px;
                  h4 {
                    font-weight: normal;
                    width: 40px;
                    font-size: 20px;
                    color: #ffffff;
                  }
                }
                .name-bt-r {
                  span {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    color: #333333;
                  }
                  p {
                    margin-top: 13px;
                    font-size: 22px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 30px;
                    letter-spacing: 0px;
                    color: #333333;
                  }
                }
              }
            }
          }
          .teacherInfo-ct-bt {
            display: flex;
            h5 {
              margin-right: 5px;
              font-weight: normal;
              font-size: 22px;
              color: #333333;
            }
            ul {
              display: flex;
              li {
                position: relative;
                margin: 0 5px;
                cursor: pointer;
                text-align: center;
                line-height: 32px;
                width: 108px;
                height: 32px;
                color: #5bab52;
                border-radius: 16px;
                border: solid 1px #5bab52;
                > img {
                  display: none;
                  position: absolute;
                  width: 143px;
                  top: 35px;
                  left: -16.5px;
                }
              }
              > li:hover {
                img {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }

  .tcDetails-bt {
    margin-top: 58px;

    .tcDetails-title {
      margin-top: 58px;
      display: flex;
      justify-content: center;
      margin-bottom: 73px;
      > h3 {
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
      }
    }

    margin-top: 189px;
    > img {
      width: 1200px;
    }
  }
  .tcDetails-bt-class {
    margin-bottom: 158px;
    margin-top: 158px;

    .tcDetails-title {
      margin-top: 58px;
      display: flex;
      justify-content: center;
      margin-bottom: 73px;
      > h3 {
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
      }
    }
    .test-ct {
      ul {
        display: flex;
        justify-content: space-between;
        .test-ct-li {
          cursor: pointer;
          width: 286px;
          height: 304px;
          .class-bg {
            position: relative;
            .class-bt {
              z-index: 11;
              width: 48px;
              height: 48px;
              top: 50%;
              left: 50%;
              margin-left: -24px;
              margin-top: -24px;
              opacity: 0.3;
              position: absolute;
            }
            .class-text {
              position: absolute;
              display: flex;
              align-items: center;
              width: 100%;
              height: 100%;
            }
            h5 {
              margin-left: 22px;
              width: 126px;
              font-size: 14px;
              font-weight: normal;
              color: #ffffff;
              opacity: 0.9;
            }
            > img {
              display: block;
              width: 286px;
              height: 166px;
              background-color: #52c65f;
              border-radius: 4px 4px 0px 0px;
            }
          }

          .test-ct-text {
            box-sizing: border-box;
            padding: 16px 10px;
            width: 286px;
            height: 140px;
            background-color: #ffffff;
            box-shadow: 0px 1px 6px 0px rgba(18, 179, 117, 0.26);
            border-radius: 0px 0px 4px 4px;

            > h3 {
              width: 265px;
              height: 25px;
              font-size: 22px;
              font-weight: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .text-c {
              margin-top: 20px;
              height: 28px;
              display: flex;
              align-items: flex-end;
              > i {
                margin-right: 13px;
                font-style: normal;
                width: 54px;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
              }
              > span {
                display: inline-block;
                width: 196px;
                font-size: 14px;
                font-weight: normal;
                letter-spacing: 0px;
                color: #999999;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .text-bt {
              display: flex;
              margin-top: 12px;
              p {
                margin-right: 32px;
                width: 48px;
                height: 12px;
                font-size: 12px;
                line-height: 30px;
                letter-spacing: 0px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
  .award {
    margin-top: 144px;
    position: relative;
    width: 1200px;
    background-color: #ffffff;
    box-shadow: 0px 2px 7px 0px rgba(74, 145, 66, 0.22);
    border-radius: 10px;
    > ul {
      position: absolute;
      top: -60px;
      left: 50%;
      margin-left: -532px;
      display: flex;
      li {
        cursor: pointer;
        width: 230px;
        height: 60px;
        font-size: 28px;
        text-align: center;
        line-height: 60px;
        margin: 0 18px;
        color: #5bab52;
        background-color: #bcecb5;
        border-radius: 14px 14px 0px 0px;
      }
      .active {
        color: #fff;
        background-color: #5bab52;
      }
    }
    .award-ct {
      padding: 68px 54px;

      .award-c-top {
        display: flex;
        justify-content: space-between;
        p {
          width: 711px;
          font-size: 20px;
          font-weight: normal;
          line-height: 36px;
          color: #333333;
        }
        i {
          font-style: normal;
          color: #5bab52;
        }
      }
      .award-c-m {
        height: 196px;
        display: flex;
        margin-top: 75px;
        .head {
          margin-right: 37px;
        }
        .info {
          width: 850px;
          .basic {
            display: flex;
            justify-content: space-between;
            .self {
              .name {
                display: flex;
                align-items: flex-end;
                > h4 {
                  font-size: 30px;
                  font-weight: normal;
                  line-height: 30px;
                  color: #333333;
                  margin-right: 22px;
                }
              }
              .condition {
                margin-top: 25px;

                display: flex;
                .school {
                  display: flex;
                  margin-right: 74px;
                  > h5 {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    color: #999999;
                  }
                  > span {
                    line-height: 30px;
                    font-size: 18px;
                    font-weight: normal;
                    color: #333333;
                  }
                }
                .qe {
                  display: flex;
                  > h5 {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    color: #999999;
                  }
                  > span {
                    line-height: 30px;
                    font-size: 18px;
                    font-weight: normal;
                    color: #333333;
                  }
                }
              }
            }
            .score {
              width: 124px;
              height: 89px;
              background-color: #5bab52;
              border-radius: 4px;
              text-align: center;
              box-sizing: border-box;
              padding-top: 12px;
              i {
                font-style: normal;
                font-size: 14px;
                font-weight: normal;
                line-height: 30px;
                color: #ffffff;
              }
              .shu {
                text-align: center;
                span {
                  font-size: 28px;
                  color: #ffffff;
                }
                i {
                  font-size: 16px;
                }
              }
            }
          }
          .text {
            margin-top: 40px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            color: #333333;
          }
        }
      }
      .award-c-bt {
        padding-top: 75px;
        border-top: 1px dotted #ddd;
        height: 196px;
        display: flex;
        margin-top: 75px;
        .head {
          margin-right: 37px;
        }
        .info {
          width: 850px;
          .basic {
            display: flex;
            justify-content: space-between;
            .self {
              .name {
                display: flex;
                align-items: flex-end;
                > h4 {
                  font-size: 30px;
                  font-weight: normal;
                  line-height: 30px;
                  color: #333333;
                  margin-right: 22px;
                }
              }
              .condition {
                margin-top: 25px;

                display: flex;
                .school {
                  display: flex;
                  margin-right: 74px;
                  > h5 {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    color: #999999;
                  }
                  > span {
                    line-height: 30px;
                    font-size: 18px;
                    font-weight: normal;
                    color: #333333;
                  }
                }
                .qe {
                  display: flex;
                  > h5 {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 30px;
                    color: #999999;
                  }
                  > span {
                    line-height: 30px;
                    font-size: 18px;
                    font-weight: normal;
                    color: #333333;
                  }
                }
              }
            }
            .score {
              width: 124px;
              height: 89px;
              background-color: #5bab52;
              border-radius: 4px;
              text-align: center;
              box-sizing: border-box;
              padding-top: 12px;
              i {
                font-style: normal;
                font-size: 14px;
                font-weight: normal;
                line-height: 30px;
                color: #ffffff;
              }
              .shu {
                text-align: center;
                span {
                  font-size: 28px;
                  color: #ffffff;
                }
                i {
                  font-size: 16px;
                }
              }
            }
          }
          .text {
            margin-top: 40px;

            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            color: #333333;
          }
        }
      }
    }
  }
  .confession {
    > ul {
      display: flex;
      li {
        flex: 1;
        width: 278px;
        height: 342px;
        position: relative;
        .confession-text {
          width: 278px;
          height: 342px;
          box-sizing: border-box;
          position: absolute;
          padding: 50px 23px 10px 23px;
          top: 0;
          .name {
            font-size: 18px;
            width: 118px;
            height: 36px;
            margin: 0 auto;
            background-color: #5bab52;
            border-radius: 18px;
            color: #fff;
            font-weight: normal;
            text-align: center;
            line-height: 36px;
          }
          > p {
            margin-left: 5px;
            margin-top: 34px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            line-height: 30px;
            color: #333333;
          }
        }
      }
    }
  }
  #ranking {
    width: 1200px;
    height: 450px;
    margin-bottom: 100px;
    display: flex;
    .active {
      color: #fff;
      background-color: #5bab52;
    }
    .table {
      margin-top: 70px;
      margin-left: 35px;
      /deep/.is-leaf {
        font-size: 22px;
        font-weight: normal;
        text-align: center;
        color: #ffffff;
        background: #6dbb64;
      }
      /deep/.el-table__body .el-table__row {
        font-size: 16px;
        font-weight: normal;
        color: #000033;
      }
      /deep/.el-table__body .el-table__row:nth-child(2n + 2) {
        text-align: center;
        background: #dfffdb;
      }

      // /deep/.el-table__body-wrapper::-webkit-scrollbar {
      //   width: 0 !important;
      // }
      /deep/.el-table__body {
        width: 1126px !important;
      }
      /deep/.gutter {
        display: none;
      }
      /deep/.el-table::before {
      }
      /deep/.el-table__body-wrapper {
      }
    }
  }

  .floatewm {
    z-index: 99;
    position: fixed;
    right: 17px;
    top: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/videodetails.vue